import GenericNoContentDueToFilteringError from './GenericNoContentDueToFilteringError';
import { jsx as _jsx } from "react/jsx-runtime";
const NoResultsError = ({
  resetLink,
  onReset
}) => /*#__PURE__*/_jsx(GenericNoContentDueToFilteringError, {
  headingI18n: "noResultsFound",
  onReset: onReset,
  resetLink: resetLink,
  subtitleI18n: "subtitle"
});
export default NoResultsError;